// Locale strings of report 2.6 (accounting-balance), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "ميزان المحاسبة (الرصيد التراكمي)",
  title: "ميزان المحاسبة (الرصيد التراكمي)",
  reportDate: "تاريخ التقرير",
  yearStart: "بداية العام",
  maxLevel: "المستوى",
  allLevels: "كل المستويات",
  accountType: "نوع الحساب",
  allTypes: "كل الأنواع",
  types: {
    ASSET: "أصول",
    LIABILITY: "التزامات",
    EQUITY: "حقوق ملكية",
    REVENUE: "إيرادات",
    EXPENSE: "مصاريف",
  },
  parentAccount: "الحساب الأب",
  hideZero: "إخفاء الأصفار",
  showChildren: "إظهار الحسابات الفرعية",
  balanceFrom: "الرصيد من",
  balanceTo: "الرصيد إلى",
  search: "بحث (رمز أو اسم الحساب)",
  columns: {
    serial: "#",
    code: "رمز الحساب",
    name: "اسم الحساب",
    level: "المستوى",
    parent: "الحساب الأب",
    normalBalance: "طبيعة الرصيد",
    balance: "الرصيد",
    balanceSide: "نوع الرصيد",
    notes: "ملاحظات",
  },
  summaryTitle: "ملخص التقرير",
  accountsCount: "عدد الحسابات",
  debitTotal: "إجمالي الأرصدة المدينة",
  creditTotal: "إجمالي الأرصدة الدائنة",
  difference: "الفرق",
  status: "الحالة",
  abnormalCount: "عدد الأرصدة غير الطبيعية",
  ledgerStatus: "توازن الدفاتر",
  scopedSummary: "الملخص محسوب ضمن نطاق التصفية (الحساب الأب / نوع الحساب)",
  unclassified: "غير مصنّف",
  contextRow: "يظهر للحفاظ على شجرة الحسابات (خارج التصفية)",
  alertsTitle: "التنبيهات",
  notesTitle: "ملاحظات",
  sheetName: "ميزان المحاسبة",
  periodLine: "من {from} إلى {to}",
};
